// buzhebugou/frontend/src/config/tabConfig.js

// 平台主题颜色配置
export const PLATFORM_COLORS = {
  // 全部 - 默认使用天猫红
  all: {
    bgGradient: 'linear-gradient(135deg, #fd0036 0%, #ff4d6a 100%)',
    primary: '#fd0036',
    secondary: '#ff4d6a',
    text: '#fff'
  },
  // 京东
  jd: {
    bgGradient: 'linear-gradient(135deg, #fd0000 0%, #ff4d4d 100%)',
    primary: '#fd0000',
    secondary: '#ff4d4d',
    text: '#fff'
  },
  // 天猫
  tm: {
    bgGradient: 'linear-gradient(135deg, #fd0036 0%, #ff4d6a 100%)',
    primary: '#fd0036',
    secondary: '#ff4d6a',
    text: '#fff'
  },
  // 淘宝
  tbb: {
    bgGradient: 'linear-gradient(135deg, #FF8C00 0%, #ffab4d 100%)',
    primary: '#FF8C00',
    secondary: '#ffab4d',
    text: '#fff'
  },
  // 唯品会
  wpp: {
    bgGradient: 'linear-gradient(135deg, #E0115F 0%, #f06292 100%)',
    primary: '#E0115F',
    secondary: '#f06292',
    text: '#fff'
  },
  // 抖音
  dyy: {
    bgGradient: 'linear-gradient(135deg, #1C1C1C 0%, #4a4a4a 100%)',
    primary: '#1C1C1C',
    secondary: '#4a4a4a',
    text: '#FFD700'
  },
  // 拼多多
  pdd: {
    bgGradient: 'linear-gradient(135deg, #FF1744 0%, #ff6b6b 100%)',
    primary: '#FF1744',
    secondary: '#ff6b6b',
    text: '#FFED00'
  }
};

// 获取平台颜色配置
export const getPlatformColors = (platform) => {
  if (platform === 'all') {
    return PLATFORM_COLORS.all;
  }
  return PLATFORM_COLORS[platform] || PLATFORM_COLORS.all;
};

export const DEFAULT_TAB_LIST = [
  {
    key: 'tmm',
    dataKey: 'tm',
    name: '猫啊猫',
    path: '/TmmContent',
    theme: 'themeTmm',
    fieldMap: {
      title: 'goods_name',
      shortTitle: 'goods_name',
      image: 'goods_img',
      imgUrl: 'goods_img',
      price: 'price',
      finalPrice: 'price',
      originalPrice: 'original_price',
      salesCount: 'sales_count',
      sales: 'sales_count',
      couponUrl: 'coupon_url',
      clickUrl: 'click_url',
      skuId: 'sku_id'
    }
  },
  {
    key: 'tbb',
    dataKey: 'tbb',
    name: '淘啊淘',
    path: '/TbbContent',
    theme: 'themeTbb',
    fieldMap: {
      title: 'goods_name',
      shortTitle: 'goods_name',
      image: 'goods_img',
      imgUrl: 'goods_img',
      price: 'price',
      finalPrice: 'price',
      originalPrice: 'original_price',
      salesCount: 'sales_count',
      sales: 'sales_count',
      couponUrl: 'coupon_url',
      clickUrl: 'click_url',
      skuId: 'sku_id'
    }
  },
  {
    key: 'jdd',
    dataKey: 'jd',
    name: '东啊东',
    path: '/JddContent',
    theme: 'themeJdd',
    fieldMap: {
      title: 'goods_name',
      shortTitle: 'goods_name',
      image: 'goods_img',
      imgUrl: 'goods_img',
      price: 'price',
      finalPrice: 'price',
      originalPrice: 'original_price',
      salesCount: 'sales_count',
      sales: 'sales_count',
      couponUrl: 'coupon_url',
      clickUrl: 'click_url',
      skuId: 'sku_id'
    }
  },
  {
    key: 'wpp',
    dataKey: 'wpp',
    name: '唯啊唯',
    path: '/WppContent',
    theme: 'themeWpp',
    fieldMap: {
      title: 'title',
      shortTitle: 'title',
      image: 'imgUrl',
      imgUrl: 'imgUrl',
      price: 'finalPrice',
      finalPrice: 'finalPrice',
      originalPrice: 'originalPrice',
      salesCount: 'salesCount',
      sales: 'salesCount',
      couponUrl: 'couponUrl',
      clickUrl: 'clickUrl',
      skuId: 'id'
    }
  },
  // {
  //   key: 'dyy',
  //   dataKey: 'dyy',
  //   name: '抖啊抖',
  //   path: '/DyyContent',
  //   theme: 'themeDyy',
  //   fieldMap: {
  //     title: 'goods_name',
  //     shortTitle: 'goods_name',
  //     image: 'goods_img',
  //     imgUrl: 'goods_img',
  //     price: 'price',
  //     finalPrice: 'price',
  //     originalPrice: 'original_price',
  //     salesCount: 'sales_count',
  //     sales: 'sales_count',
  //     couponUrl: 'coupon_url',
  //     clickUrl: 'click_url',
  //     skuId: 'sku_id'
  //   }
  // },
  {
    key: 'pdd',
    dataKey: 'pdd',
    name: '拼啊拼',
    path: '/PddContent',
    theme: 'themePdd',
    fieldMap: {
      title: 'goods_name',
      shortTitle: 'goods_name',
      image: 'goods_img',
      imgUrl: 'goods_img',
      price: 'price',
      finalPrice: 'price',
      originalPrice: 'original_price',
      salesCount: 'sales_count',
      sales: 'sales_count',
      couponUrl: 'coupon_url',
      clickUrl: 'click_url',
      skuId: 'sku_id'
    }
  }
]

// 统一的平台别名映射
export const PLATFORM_ALIAS_MAP = {
  jdd: 'jd',
  JdPlatform: 'jd',
  jd: 'jd',
  tmm: 'tm',
  tbb: 'tb',
  taobao: 'tb',
  tmall: 'tm',
  tm: 'tm',
  tb: 'tb',
  pdd: 'pdd',
  wpp: 'wpp',
  WppPlatform: 'wpp',
  dyy: 'dyy'
};

// 前端平台值转后端平台值（统一版本）
export const getBackendPlatform = (platform) => {
  return PLATFORM_ALIAS_MAP[platform] || platform;
}

// 后端平台值转前端平台值
export const getFrontPlatform = (backendPlatform) => {
  const reverseMap = {
    jd: 'jd',
    tm: 'tm',
    tb: 'tb',
    pdd: 'pdd',
    wpp: 'wpp',
    dyy: 'dyy'
  }
  return reverseMap[backendPlatform] || backendPlatform;
}

// 将前端Tab的key转换为后端识别的platform值
export const convertTabKeyToPlatform = (tabKey) => {
  return PLATFORM_ALIAS_MAP[tabKey] || tabKey;
};

// 将后端platform值转换为前端Tab的key
export const convertPlatformToTabKey = (platform) => {
  // eslint-disable-next-line no-unused-vars
  const reverseMap = Object.entries(PLATFORM_ALIAS_MAP).find(([k, v]) => v === platform);
  return reverseMap ? reverseMap[0] : platform;
};

// 获取指定平台的字段映射配置
export const getPlatformFieldMap = (platform) => {
  const defaultFieldMap = DEFAULT_TAB_LIST.find(item => item.dataKey === 'jd')?.fieldMap;
  const backendPlatform = getBackendPlatform(platform);
  const normalizedKey = backendPlatform === 'tm' ? 'tm' : (backendPlatform === 'tb' ? 'tbb' : backendPlatform);
  const targetTab = DEFAULT_TAB_LIST.find(item => item.dataKey === normalizedKey);
  return targetTab?.fieldMap || defaultFieldMap;
}

// 获取指定平台的配置信息
export const getPlatformConfig = (platform) => {
  return DEFAULT_TAB_LIST.find(item => item.dataKey === platform) || {};
}

// 统一平台标识转换（tm -> tmall，用于后端API）
export const normalizePlatform = (platform) => {
  const backendPlatform = getBackendPlatform(platform);
  // 后端需要 tmall 而不是 tm
  return backendPlatform === 'tm' ? 'tmall' : backendPlatform;
}
